import { datadogRum } from '@datadog/browser-rum';
var initialized = false;
var ENVS_TO_LOG = ['production', 'staging'];
var isInProdOrStaging = ENVS_TO_LOG.includes(process.env.ENVIRONMENT);
var isANonDevelopmentBuild = process.env.NODE_ENV !== 'development';
if (isInProdOrStaging && isANonDevelopmentBuild) {
    datadogRum.init({
        applicationId: '4ca8e8ef-3eca-4558-93db-25444266883c',
        clientToken: 'pub1729f4f46cadf2df450839f4ec2f08da',
        site: 'datadoghq.com',
        service: 'link',
        env: process.env.ENVIRONMENT,
        version: '2.3.0',
        sampleRate: 50,
        trackInteractions: true,
        // We don't use a URL-based router, so RUM can't automatically
        // determine when a new view is loaded, so we need to handle identification
        // manually.
        trackViewsManually: true,
        // For some reason enabling allowedTracingOrigins breaks our RUM sessions
        // https://github.com/underdog-tech/link/pull/635
        // allowedTracingOrigins: [/https:\/\/.*\.(getpinwheel|pinwheelapi)\.com/]
        defaultPrivacyLevel: 'mask-user-input',
    });
    initialized = true;
}
/**
 * Manually record new views for DataDog RUM since we don't
 * use a URL-based routing framework that RUM can automatically
 * detect view changes for.
 *
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=cdnsync#override-default-rum-view-names
 *
 * @param name Stable identifier for a unique view
 */
export default (function (name) {
    if (!initialized)
        return;
    datadogRum.startView(name);
});
